import styled, { css } from 'styled-components';
import { StyledProps } from './interfaces';

const VARIANT = {
  h2: css`
    color: ${({ theme }) => theme.color.text.neutral.strong};
    font-size: ${({ theme }) => theme.font.size.m7};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    line-height: ${({ theme }) => theme.font.lineHeight.tiny};
    letter-spacing: -0.03em;
  `,
  h3: css`
    color: ${({ theme }) => theme.color.text.neutral.default};
    font-size: ${({ theme }) => theme.font.size.m4};
    font-weight: ${({ theme }) => theme.font.weight.regular};
    line-height: ${({ theme }) => theme.font.lineHeight.medium};
    letter-spacing: -0.03em;
  `,
  h4: css`
    color: ${({ theme }) => theme.color.text.neutral.strong};
    font-size: ${({ theme }) => theme.font.size.m5};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    line-height: ${({ theme }) => theme.font.lineHeight.tiny};
    letter-spacing: -0.03em;
  `,
  label: css`
    color: ${({ theme }) => theme.color.text.neutral.strong};
    font-size: ${({ theme }) => theme.font.size.m2};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    line-height: ${({ theme }) => theme.font.lineHeight.medium};
  `,
  p: css`
    color: ${({ theme }) => theme.color.text.neutral.strong};
    font-size: ${({ theme }) => theme.font.size.m2};
    line-height: ${({ theme }) => theme.font.lineHeight.medium};
  `,
  b: css`
    letter-spacing: -0.03em;
    color: ${({ theme }) => theme.color.text.neutral.weak};
    font-weight: ${({ theme }) => theme.font.weight.bold};
  `,
};

export default styled.span<StyledProps>`
  ${({ as }) => VARIANT[as]}
`;
